import {ReactComponent as ZoomInIconDisabled} from '../../assets/icons/zoom-in-disabled.svg';
import {ReactComponent as ZoomInIcon} from '../../assets/icons/zoom-in.svg';
import {ReactComponent as ZoomOutIconDisabled} from '../../assets/icons/zoom-out-disabled.svg';
import {ReactComponent as ZoomOutIcon} from '../../assets/icons/zoom-out.svg';
import { maxZoomFactor, minZoomFactor } from '../Solution/Preview.types';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { useStyles } from '../../components/Solution/Toolbar.styles';
import { IconButton } from '@material-ui/core';
import { fill, fillOpacity } from '../../utils/contrastSvgAttributes';

interface ZoomInOutProps {
  zoomFactor: number;
  handleZoomIn: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleZoomOut: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const ZoomInOut: React.FC<ZoomInOutProps> = (props) => {
  const classes = useStyles();
  return (
    <>
      <TooltipOne title={'Powiększ'} placement="top" arrow>
        <IconButton  disableRipple onClick={props.handleZoomIn} className={props.zoomFactor < maxZoomFactor  ? '' : classes.cardPreviewMenuIconDisabled}>
          {props.zoomFactor < maxZoomFactor ? <ZoomInIcon title="ikona powiększ" fill={fill} /> : <ZoomInIconDisabled title="ikona powiększ" fill={fill} fillOpacity={fillOpacity}/>}
        </IconButton>
      </TooltipOne>
      <TooltipOne title={'Pomniejsz'} placement="top" arrow>
        <IconButton  disableRipple  onClick={props.handleZoomOut} className={props.zoomFactor > minZoomFactor ? '' : classes.cardPreviewMenuIconDisabled}>
          {props.zoomFactor > minZoomFactor ? <ZoomOutIcon title="ikona pomniejsz" fill={fill}  /> : <ZoomOutIconDisabled  title="ikona pomniejsz" fill={fill} fillOpacity={fillOpacity}/>}
        </IconButton>
      </TooltipOne>
    </>
  );
};
